import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class PrintInvoiceHistoryService  extends DatabaseGwService{

  URL_PATH: string ="/printed-invoices";
}
